export default "__VITE_ASSET__D641tJyA__"